const actionTypeIdentifier = '3D74F5FC-BE8A-4599-A14F-56B8A8AD3CB6';

export const getInventoryASR = `GET-ASR-EXTERNAL-INVENTORY-${actionTypeIdentifier}`;
export const setInventoryASRError = `SET-ASR-EXTERNAL-INVENTORY-ERROR-${actionTypeIdentifier}`;
export const setInventoryASRColSearchStr = `SET-ASR-EXTERNAL-INVENTORY-COL-SEARCH-STRING-${actionTypeIdentifier}`;
export const sortInventoryASRItems = `SORT-ASR-EXTERNAL-INVENTORY-${actionTypeIdentifier}`;
export const setInventoryASRPageSize = `SET-INVENTORY-ASR-PAGESIZE-${actionTypeIdentifier}`;
export const setInventoryASRFilter = `SET-INVENTORY-ASR-FILTER-${actionTypeIdentifier}`;
export const applyInventoryASRFilter = `APPLY-INVENTORY-ASR-FILTER-${actionTypeIdentifier}`;
export const resetInventoryASRData = `RESET-INVENTORY-ASR-DATA-${actionTypeIdentifier}`;